<template>
  <div class="accordion">
    <div
      class="accordion-title"
      :class="{'accordion-title-active':isOpen}"
      @click="open()">
      <slot name="title"></slot>
      <transition
        name="rotate"
        mode="out-in">
        <span
          v-if="isOpen"
          key="rotate1"
          class="fas fa-chevron-up"></span>
        <span
          v-else
          key="rotate2"
          class="fas fa-chevron-down"></span>
      </transition>
    </div>
    <transition name="open">
      <div
        v-if="isOpen"
        class="accordion-content">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    open() {
      // this.isOpen = !this.isOpen
      this.$emit('toggle')
    },
  },
}
</script>
